import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

const hotArticles = articles.filter((a) => a.hot).slice(0, 4);
const latestArticles = articles.slice(0, 8);

export default function Home() {
  return (
    <>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20moody%20entertainment%20news%20studio%20background%20with%20dramatic%20golden%20spotlight%20effects%20and%20abstract%20geometric%20lines%2C%20warm%20deep%20brown%20and%20cream%20color%20palette%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20style%2C%20soft%20theatrical%20lighting%2C%20elegant%20minimalist%20composition%20with%20rich%20textures%20and%20negative%20space&width=1600&height=900&seq=hero-home-main&orientation=landscape"
              alt="五一黑料网 - 黑料爆料每日追踪"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/25 to-black/55"></div>
          </div>

          <div className="relative z-10 w-full px-4 md:px-6">
            <div className="w-full max-w-[1400px] mx-auto">
              <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
                <div className="flex-1 text-center lg:text-left pt-20 lg:pt-0">
                  <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight tracking-tight">
                    黑料追踪
                    <br />
                    <span className="italic text-accent-300">绝不放过</span>
                    任何一个瓜
                  </h1>
                  <p className="mt-5 text-sm md:text-base text-background-200/90 leading-relaxed max-w-lg mx-auto lg:mx-0">
                    五一黑料网官网直达入口，7×24小时全天候监控娱乐圈与网红圈动态。
                    聚合网红黑料、明星塌房、博主爆料，一手猛料极速送达，吃瓜永远快人一步。
                  </p>
                  <div className="flex flex-col sm:flex-row items-center gap-3 mt-7 justify-center lg:justify-start">
                    <Link
                      to="/category/wanghong-heliao"
                      className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
                    >
                      立即吃瓜
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                    <Link
                      to="/about"
                      className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-background-50 text-sm font-medium hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
                    >
                      了解我们
                    </Link>
                  </div>
                </div>

                <div className="flex-1 w-full max-w-lg lg:max-w-none">
                  <div className="relative rounded-2xl overflow-hidden aspect-[4/3] lg:aspect-[5/4]">
                    <img
                      src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photo%20of%20vintage%20newspapers%20and%20magnifying%20glass%20on%20dark%20desk%2C%20warm%20golden%20and%20deep%20brown%20tones%2C%20cinematic%20atmosphere%2C%20investigative%20journalism%20theme%2C%20soft%20dramatic%20side%20lighting%2C%20rich%20textures%2C%20elegant%20composition&width=900&height=700&seq=hero-home-side&orientation=landscape"
                      alt="五一黑料网 - 娱乐八卦爆料追踪"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="inline-block px-4 py-1.5 text-xs font-semibold rounded-full border border-background-300 text-foreground-600 whitespace-nowrap">
                爆料分类
              </span>
              <h2 className="mt-4 text-2xl md:text-3xl font-heading font-bold text-foreground-900 tracking-tight">
                热门爆料分类
              </h2>
              <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
                按分类追踪你最关心的八卦猛料，不错过任何一个吃瓜现场
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/60 hover:bg-primary-500 transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-lg bg-background-200 flex items-center justify-center group-hover:bg-white/20 transition-colors duration-300">
                    <i className={`${cat.icon} text-lg text-foreground-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                  </div>
                  <h3 className="mt-4 text-sm font-semibold text-foreground-800 group-hover:text-background-50 transition-colors duration-300 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-500 group-hover:text-background-200/80 transition-colors duration-300 leading-relaxed line-clamp-2">
                    {cat.description}
                  </p>
                  <div className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-500 group-hover:text-background-50 transition-colors duration-300 whitespace-nowrap">
                    浏览全部
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles Section */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 tracking-tight">
                  最新猛料
                </h2>
                <p className="mt-1 text-sm text-foreground-500">
                  实时追踪，极速更新
                </p>
              </div>
              <Link
                to="/category/wanghong-heliao"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {latestArticles.slice(0, 4).map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {latestArticles.slice(4, 8).map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* CTA Split Section */}
        <section className="w-full flex flex-col lg:flex-row">
          <div className="lg:w-1/2 relative min-h-[380px] md:min-h-[480px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cream%20and%20beige%20abstract%20textured%20background%20with%20soft%20gradient%2C%20elegant%20minimalist%20atmosphere%2C%20subtle%20geometric%20patterns%2C%20warm%20natural%20light%2C%20editorial%20photography%20style%2C%20calm%20and%20sophisticated%20composition&width=900&height=700&seq=cta-split-left&orientation=landscape"
              alt="五一黑料网品牌形象"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-100/40 to-transparent"></div>
            <div className="absolute top-8 left-8">
              <span className="text-[11px] font-medium text-foreground-700 uppercase tracking-wider whitespace-nowrap">
                五一黑料网
              </span>
            </div>
            <div className="absolute bottom-10 left-8 right-8">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight tracking-tight">
                吃瓜不吃假瓜
                <br />
                爆料要有实锤
                <br />
                追踪永不停歇
              </h2>
            </div>
          </div>

          <div className="lg:w-1/2 bg-background-50 flex items-center justify-center py-16 px-8 md:px-16">
            <div className="text-center max-w-md">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 leading-tight tracking-tight">
                不想错过
                <br />
                任何一个猛料？
              </h2>
              <p className="mt-5 text-sm text-foreground-600 leading-relaxed">
                五一黑料网每日更新最新八卦爆料，从网红翻车到明星塌房，从综艺吃瓜到影视内幕，
                你关心的黑料都在这里。收藏本站，吃瓜永远快人一步。
              </p>
              <Link
                to="/category/mingxing-tafang"
                className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
              >
                去看看最新爆料
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '五一黑料网 - 首页',
            url: 'https://www.wuyiheiliao.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '五一黑料网',
              url: 'https://www.wuyiheiliao.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.wuyiheiliao.com/',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}